import {
  Gender
} from "../enum";

export const genderOptions = [
  {
    label: Gender.Male,
    value: Gender.Male,
  },
  {
    label: Gender.Female,
    value: Gender.Female,
  },
  {
    label: Gender.Other,
    value: Gender.Other,
  },
];

export const countryOptions = [
  {
    label: 'India',
    value: 'India',
  },
];

export const stateOptions = [
  {
    label: 'Kerala',
    value: 'Kerala',
  },
];

export const cityOptions = [
  {
    label: 'Ernakulam',
    value: 'Ernakulam',
  },
];
